import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle, Zap, Download, ShieldCheck } from 'lucide-react';
import { Button } from './Button';
export function Benefits() {
  const includes = ['Guía práctica completa: Cómo vender en Amazon FBA desde cero (2026)', 'Bono #1: Lista de productos con potencial real para vender', 'Bono #2: Plantilla práctica para identificar productos ganadores', 'Bono #3: Checklist completo para lanzar sin errores'];
  const transformation = ['Entender cómo funciona Amazon sin confusión', 'Tener claridad sobre qué productos vender', 'Dar tu primer paso hacia ingresos online', 'Dejar de perder tiempo en información suelta', 'Construir algo real desde casa'];
  return <section className="bg-brand-white py-20 px-6" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        {/* Qué incluye */}
        <FadeIn data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-green mb-12" data-id="element-77">
            ¿QUÉ INCLUYE TU COMPRA?
          </h2>
        </FadeIn>

        <div className="bg-brand-beige rounded-3xl p-8 md:p-12 mb-8" data-id="element-78">
          <div className="space-y-6" data-id="element-79">
            {includes.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-80">
                <div className="flex items-center gap-4" data-id="element-81">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-82" />
                  <p className="text-xl text-brand-text font-medium" data-id="element-83">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.5} data-id="element-84">
          <p className="text-lg text-brand-text/80 text-center mb-20" data-id="element-85">
            No solo aprenderás… Tendrás herramientas listas para aplicar desde
            el primer día y evitar errores que hacen perder dinero.
          </p>
        </FadeIn>

        {/* Transformación */}
        <FadeIn delay={0.6} data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-green mb-12" data-id="element-87">
            DESPUÉS DE ESTE SISTEMA PODRÁS:
          </h2>
        </FadeIn>

        <div className="bg-brand-beige rounded-3xl p-8 md:p-12" data-id="element-88">
          <div className="space-y-6" data-id="element-89">
            {transformation.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-90">
                <div className="flex items-center gap-4" data-id="element-91">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-92" />
                  <p className="text-xl text-brand-text font-medium" data-id="element-93">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        {/* CTA Button */}
        <FadeIn delay={0.8} data-id="element-94">
          <div className="text-center mt-14" data-id="element-95">
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank')} className="w-full sm:w-auto text-lg md:text-xl px-14 py-5" data-id="element-96">
              QUIERO EMPEZAR AHORA EN AMAZON FBA
            </Button>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-97">
              <span className="flex items-center gap-1.5" data-id="element-98">
                <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-99" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5" data-id="element-100">
                <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-101" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5" data-id="element-102">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-103" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}